import React from "react";
import { capitalize } from "@mui/material";
import { getPlanIntervalLabel } from "./utils";

const SubscriptionPlanCard = ({
  plan,
  isForFreeTrial,
  isCurrentPlan,
  handleChangePlan,
}) => {
  return (
    <div className="plansWrap__list__item" key={plan.id}>
      <div className="card">
        {!isForFreeTrial ? (
          <h2 className="title">{capitalize(plan?.planType ?? "")}</h2>
        ) : null}
        <div className="card__info">
          <div
            className="card__info__item"
            style={{
              height: "400px",
              justifyContent: "flex-start",
            }}
          >
            <div className="card__info__flexRow">
              <h3>
                <span className="form__label">Plan Name</span>
                {plan?.name}
              </h3>
              <h3 style={{ textAlign: "right", gap: 0 }}>
                <span className="form__label">Price</span>
                <h5
                  className="price"
                  style={{
                    fontSize: "1.25rem",
                    lineHeight: "30px",
                  }}
                >
                  ${plan?.price} <span>/{plan?.numberOfCredits} Credits</span>
                </h5>
              </h3>
            </div>
            <div className="card__info__flexRow">
              <h3>
                <span className="form__label">
                  Subscription
                  <sup className="form__label__asterisk">*</sup>
                </span>
                {getPlanIntervalLabel(plan)}
              </h3>
              <h3 style={{ textAlign: "right" }}>
                <span className="form__label">No. of Assistants</span>
                {plan?.planTypeDetails?.noOfAssistants}
              </h3>
            </div>
            {plan?.planTypeDetails?.isAdditionalAssistant ? (
              <div className="card__info__flexRow">
                <h3>
                  <span className="form__label">
                    Additional No. of Assistants
                    <sup className="form__label__asterisk">*</sup>
                  </span>
                  {plan?.planTypeDetails?.additionalAssistant}
                </h3>
                <h3 style={{ textAlign: "right" }}>
                  <span className="form__label">Price per Assistant</span>$
                  {plan?.planTypeDetails?.amount}
                </h3>
              </div>
            ) : null}
            <h4>Features</h4>
            <ul className="list">
              {plan?.planTypeDetails?.features?.map((feat) => (
                <li key={feat.name}>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.5892 0.471191C9.32128 0.471191 7.10427 1.14371 5.21855 2.40371C3.33283 3.66371 1.86309 5.4546 0.995185 7.5499C0.127283 9.6452 -0.0998 11.9508 0.342653 14.1752C0.785106 16.3995 1.87722 18.4427 3.4809 20.0464C5.08457 21.6501 7.12778 22.7422 9.35214 23.1847C11.5765 23.6271 13.8821 23.4 15.9774 22.5321C18.0727 21.6642 19.8636 20.1945 21.1236 18.3088C22.3836 16.423 23.0561 14.206 23.0561 11.9381C23.0561 8.89688 21.848 5.98023 19.6975 3.82977C17.5471 1.67931 14.6304 0.471191 11.5892 0.471191ZM9.95109 16.5167L5.85577 12.4213L7.15808 11.119L9.95109 13.912L16.0204 7.84277L17.3276 9.14181L9.95109 16.5167Z"
                      fill="#8b58f1"
                    />
                  </svg>
                  {feat.name}
                </li>
              ))}
            </ul>
          </div>
          <div className="card__info__item">
            {isCurrentPlan ? (
              <button className="btn btn__primary btn--currentPlan" disabled>
                Current Plan
              </button>
            ) : (
              <button
                className="btn btn__primary"
                onClick={() => handleChangePlan(plan)}
              >
                Change Plan
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPlanCard;
